var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.844,
    height: 35.876,
    viewBox: "0 0 36.844 35.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_67",
    x: 0,
    y: 3.186,
    width: 36.844,
    height: 32.691,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success-icon",
    transform: "translate(2.223)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1151",
    "data-name": "Ellipse 1151",
    cx: 16,
    cy: 16.205,
    rx: 16,
    ry: 16.205,
    fill: "#32d7be"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2.22, 0)",
    filter: "url(#Union_67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_67-2",
    "data-name": "Union 67",
    d: "M6.155,14.215.469,8.394a1.728,1.728,0,0,1,0-2.368l1.3-1.32a1.665,1.665,0,0,1,2.329,0L7.311,8,14.746.48a1.651,1.651,0,0,1,2.329,0l1.3,1.318a1.717,1.717,0,0,1,0,2.363l-8.417,8.52a1.468,1.468,0,0,1-.179.216L8.484,14.215a1.662,1.662,0,0,1-2.329,0Z",
    transform: "translate(9 9.19)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.ae4fce2c2373206c1147fb40430343e8.svg";
export { ForwardRef as ReactComponent };